<template>
  <div class="index">
    <div class="index-bannerAndSearch">
      <div class="index-banner">
        <img src="../assets/img/index/banner.png" alt="" style="width: 100%" />
      </div>
      <div class="index-search">
        <!-- <div class="index-searchBox" @click="toSearch">
          <img src="../assets/img/index/search.svg" alt="" />
          <span>请输入公众号ID、名称</span>
        </div> -->
        <div class="index-headerBox" @click="toUser">
          <img
            v-if="userInfo.headimgurl"
            :src="userInfo.headimgurl"
            alt=""
            style="width: 24px; height: 24px"
          />
          <img
            v-else
            src="../assets/img/index/header-default.svg"
            alt=""
            style="width: 20px; border-radius: 0"
          />
        </div>
      </div>
      <div
        class="index-checkPending"
        v-show="checkPendingNum > 0"
        @click="toNewPage('https://erp.newrank.cn/media/examine/project')"
      >
        <img src="../assets/img/index/header-toAde.svg" alt="" />
        <span
          >待审核<span style="color: #ff7800; margin: 0 3px">{{
            checkPendingNum
          }}</span
          >个</span
        >
      </div>
    </div>

    <!--通告-->
    <div class="index-news" v-show="moreNews.length">
      <img
        class="news-leftTitle"
        src="../assets/img/index/icon-notice.svg"
        alt=""
      />
      <div class="text-container">
        <transition class="inner-container2" name="slide" mode="out-in">
          <p
            class="text2"
            :key="text.id"
            style="max-height: 30px"
            @click="toNewPage(text.url)"
          >
            {{
              text.val && text.val.length > 22
                ? text.val.substring(0, 22) + "..."
                : text.val
            }}
          </p>
        </transition>
      </div>
      <span class="news-more" @click="showMoreNews"
        ><span style="color: #eee">|</span> more</span
      >
    </div>
    <div class="index-searchrow">
      <div class="search-row">
        <div class="search-type-container" ref="searchTypeContainer">
          <div
            class="search-type-change"
            :class="{ active: showSearchType }"
            @click.stop="toggleSearchType"
          >
            {{ searchType === "account" ? "搜账号" : "搜热度" }}&nbsp;
            <img src="../assets/img/index/img-jiantou.png" :class="{'search-type-icon': true, 'search-type-icon-active': !!showSearchType}" />
            <span class="search-type-divider">|</span>
            <div class="search-type-option" v-if="showSearchType">
              <div
                class="search-type-option-item"
                @click.stop="selectSearchType('account')"
              >
                搜账号
              </div>
              <div
                class="search-type-option-item"
                @click.stop="selectSearchType('trend')"
              >
                搜热度
              </div>
            </div>
          </div>
        </div>
        <img class="search-icon" src="../assets/img/index/search.svg" alt="" />
        <input
          type="search"
          class="search-inputrow"
          v-model="serachInput"
          @input="changeSerachInput"
          @search="handleSearch"
          :placeholder="renderTips"
        />
        <div
          class="inputBox-clear"
          v-show="!!serachInput"
          @click="clearKeyWord"
        >
          <img src="../assets/img/search/delete.svg" alt="" />
        </div>
        <div :class="{'search-btn': true, 'search-btn-trend': searchType === 'trend'}" @click="handleSearch">搜索</div>
      </div>
    </div>

    <div class="main">
      <!--产品列表-->
      <div class="index-linkList">
        <div
          class="linkList-item"
          v-for="(item, index) in linkListData"
          :key="index"
          @click="toProduct(item)"
        >
          <OpenWechat
            className="wx-open-enter"
            platform="sq"
            :isWechatEnvProp="false"
            path="pages/Rank/RankList/index"
            v-if="item.text == '品牌榜'"
          />
          <OpenWechat
            className="wx-open-enter"
            platform="sq"
            :isWechatEnvProp="false"
            path="pages/Rank/RankList/index?production=ranklist"
            v-if="item.text == '账号榜'"
          />
          <div class="linkList-bangdan-new-day" v-if="item.text == '账号榜'">
            <img
              src="../assets/img/index/bangdan-day.svg"
              alt=""
              v-if="bangdanNewStatus == 1"
            />
            <img
              src="../assets/img/index/bangdan-week.svg"
              alt=""
              v-if="bangdanNewStatus == 2"
            />
            <img
              src="../assets/img/index/bangdan-month.svg"
              alt=""
              v-if="bangdanNewStatus == 3"
            />
          </div>
          <div
            class="linkList-item-icon"
            :style="{ backgroundColor: item.color }"
          >
            <img :src="item.img" alt="" />
          </div>
          <p>{{ item.text }}</p>
        </div>
      </div>

      <swipe
        class="index-advertisement"
        v-if="bannerData.length"
        :autoplayTime="autoplayTime"
        :pagination="pagination"
      >
        <swipe-item v-for="(item, index) in bannerData" :key="index">
          <img :src="item.img_url" alt="" @click="toNewPage(item.click_url)" />
        </swipe-item>
      </swipe>

      <!-- 年度H5图片 -->
      <!-- <div class="annualH5" @click="openAnnualH5('https://cu2020.newrank.cn/')">
        <img src="../assets/img/index/annualH5.png" alt="">
      </div> -->

      <!-- newX相关入口 -->
      <div class="index-lnewXList">
        <div class="intelligence-head">
          <span class="intelligence-head-border"></span>
          <span class="intelligence-head-title">短视频直播数据工具</span>
        </div>
        <div class="index-lnewXList-box">
          <div
            @click="clickNewXItem(item.url)"
            v-for="(item, index) in lnewXList"
            :key="index"
            class="index-lnewXList-box-item"
          >
            <span>{{ item.title }}</span>
            <img :src="item.bgi" alt="" />
          </div>
        </div>
      </div>

      <!--情报-->
      <!-- <div class="index-intelligence">
        <div class="intelligence-head">
          <span class="intelligence-head-border"></span>
          <span class="intelligence-head-title">情报</span>
          <img
            @click="toInformation(1)"
            src="../assets/img/index/more-right.svg"
          />
        </div>
        <div class="intelligence-list">
          <div
            class="intelligence-list-item"
            v-for="item in intelligenceData"
            :key="item.id"
            @click="toNewPage(item.url)"
          >
            <p>
              <span class="able-remind" v-if="item.appletflag == 0"></span>
              <img
                v-else
                src="../assets/img/index/mini.svg"
                alt=""
                style="width: 10px"
              />
              {{
                item.title && item.title.length > 20
                  ? item.title.substring(0, 20) + "..."
                  : item.title
              }}
            </p>
            <p>
              <span>{{ doNull(item.insert_time).pastTime() }}</span>
            </p>
          </div>
        </div>
        <p class="information-list-more" style="margin-top: 0">
          <span @click="toInformation(1)">查看更多情报</span>
        </p>
      </div> -->
      <!--资讯-->
      <!-- <div class="index-information">
        <div class="intelligence-head">
          <span class="intelligence-head-border"></span>
          <span class="intelligence-head-title">资讯</span>
          <img
            @click="toInformation(0)"
            src="../assets/img/index/more-right.svg"
          />
        </div>
        <div class="information-list">
          <div
            class="information-list-item"
            v-for="item in informationData"
            :key="item.id"
            @click="toNewPage(item.url)"
          >
            <div class="information-list-item-content">
              <p>
                {{
                  item.title && item.title.length > 26
                    ? item.title.substring(0, 26) + "..."
                    : item.title
                }}
              </p>
              <p>
                {{
                  item.author && item.appletflag == 1 && item.author.length > 4
                    ? item.author.substring(0, 4) + "..."
                    : item.author
                }}<span style="margin-left: 15px">{{
                  item.insert_time
                    ? doNull(item.insert_time).length > 10
                      ? item.insert_time.substring(0, 10)
                      : item.insert_time
                    : ""
                }}</span>
                <span
                  class="information-item-mini"
                  v-show="item.appletflag == 1"
                  >小程序</span
                >
              </p>
            </div>
            <div
              class="information-list-item-img"
              :style="{ backgroundImage: `url(${item.cms_media_img})` }"
            >
            </div>
          </div>
          <p class="information-list-more">
            <span @click="toInformation(0)">查看更多资讯</span>
          </p>
        </div>
      </div> -->
      <p class="index-footer">©2023 NEWRANK 沪ICP备14042332号-2</p>

      <div v-if="isPhone && !isMiniApp">
        <div v-if="!isWechatEnv" class="open-wechat">
          新榜 | 前往小程序
          <OpenWechat
            className="wx-open-enter"
            platform="sq"
            :isWechatEnvProp="false"
            path="pages/Index/index?channel=index_h5"
          />
        </div>
        <div class="open-wechat-position">
          <wx-open-launch-weapp
            :ready="true"
            path="pages/Index/index?channel=index_h5"
            appid="wx550e53f8b403dd49"
            id="launch-btn-wechat"
            env-version="release"
          >
            <script type="text/wxtag-template">
              <style>
                .openBtn {
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  height: 32px;
                  width: 140px;
                  color: #fff;
                  background: linear-gradient(297deg,#ff7800,#ffb700);
                  border-radius: 16px;
                  font-size: 14px;
                }
              </style>
              <div class="openBtn">新榜 | 前往小程序</div>
            </script>
          </wx-open-launch-weapp>
        </div>
      </div>
      <div v-else-if="!isPhone && !isMiniApp" class="open-web">
        <a :href="mainUrl">新榜 | 前往官网</a>
      </div>
    </div>

    <div class="not-follow-newrank" v-show="notFollowBar">
      <div class="not-follow-newrank-close" @click="closeNotFollow">×</div>
      <div class="not-follow-newrank-text" @click="notFollow">
        尚未关注「新榜服务」，可能会走丢
      </div>
    </div>

    <Popup :codeTitle="codeTitle" :codeImg="codeImg" v-model="codeShow"></Popup>
    <BottomRouter page="index"></BottomRouter>
    <MoreNews
      :showData="moreNews"
      v-if="moreNewsShow && moreNews.length > 0"
      @hideMoreNews="hideMoreNews"
    ></MoreNews>
  </div>
</template>

<script>
import ElInput from "element-ui/lib/input";

import nr from "nr";
const common = nr.loadScript("common");
import {
  searchCmsMedia,
  mbGetMedia,
  mbSearchNews,
  newrankExhibition,
  mbGetBannerList,
  countAuditsRecordByUser,
} from "@/assets/js/api/index.js";
import { weixinShow } from "@/assets/js/common/untils.js";
import OpenWechat from "./common/openWechat.vue";
import { weixinConfig } from "@/assets/js/common/untils.js";

import BottomRouter from "./common/bottomRouter.vue";
import MoreNews from "./index/moreNews.vue";
import Popup from "./common/popup.vue";
export default {
  name: "Index",
  components: {
    BottomRouter,
    MoreNews,
    Popup,
    OpenWechat,
    ElInput,
  },
  data() {
    return {
      serachInput: "",
      userInfo: {},
      number: 0,
      newsData: [{ title: "" }],
      moreNewsShow: false,
      cancheckFollowBar: true,
      notFollowBar: false,
      codeShow: false,
      codeTitle: "",
      codeImg: "",
      moreNews: [],
      bangdanNewStatus: null,
      intelligenceData: [],
      informationData: [],
      searchType: "trend",
      showSearchType: false,
      linkListData: [
        {
          color: "rgba(0,136,255,0.15)",
          text: "品牌榜",
          url: "http://url.newrank.cn/lgBx87",
          img: require("../assets/img/product/brand.svg"),
        },
        {
          color: "rgba(255,120,0,0.15)",
          text: "账号榜",
          url: "http://url.newrank.cn/lgBx87",
          img: require("../assets/img/product/bangdan.svg"),
        },
        // {color:'rgba(119,137,219,0.15)',text:'小程序查查',url:'http://url.newrank.cn/jr0f2e',img:require('../assets/img/product/chacha.svg')},
        // {
        //   color: "rgba(122,178,235,0.15)",
        //   text: "号内搜",
        //   url: "http://url.newrank.cn/jr0m00",
        //   img: require("../assets/img/product/haoneisou.svg"),
        // },
        {
          color: "rgba(102,94,255,0.15)",
          text: "分钟级监测",
          url: "http://url.newrank.cn/rgnZ6d",
          img: require("../assets/img/product/fenzhongji.svg"),
        },
        {
          color: "rgba(253,90,125,0.15)",
          text: "公众号体检",
          url: "http://url.newrank.cn/jr0C6e",
          img: require("../assets/img/product/tijian.svg"),
        },
        {
          color: "rgba(253,90,125,0.15)",
          text: "自媒宝",
          url: "https://a.newrank.cn/zmb/app/common/home",
          img: require("../assets/img/product/zimeibao.svg"),
        },
        {
          color: "rgba(253,90,125,0.15)",
          text: "社群宝",
          url: "http://url.newrank.cn/15tGTf",
          img: require("../assets/img/product/shequn.svg"),
        },
        // {
        //   color: "rgba(255,120,0,0.15)",
        //   text: "全部",
        //   img: require("../assets/img/product/quanbu.svg"),
        // },
      ],
      bannerData: [],
      autoplayTime: 2000,
      pagination: false,
      checkPendingNum: null,
      lnewXList: [
        {
          title: "抖音数据",
          bgi: require("../assets/img/index/xd.svg"),
          url: "https://xd.newrank.cn/",
        },
        {
          title: "视频号数据",
          bgi: require("../assets/img/index/xs.svg"),
          url: "https://xs.newrank.cn/",
        },
        {
          title: "快手数据",
          bgi: require("../assets/img/index/xk.svg"),
          url: "https://xk.newrank.cn/",
        },
        {
          title: "B站数据",
          bgi: require("../assets/img/index/xz.svg"),
          url: "https://xz.newrank.cn/",
        },
        {
          title: "小红书数据",
          bgi: require("../assets/img/index/xh.svg"),
          url: "https://xh.newrank.cn/",
        },
      ],
    };
  },
  beforeCreate() {
    document.title = "新榜";
    weixinConfig();
  },
  created() {
    this.getUser();
    this.getBangdanStatus();
    this.searchNotice();
    this.getBanner();
    this.searchCmsMedia();
  },
  mounted() {
    this.wxData();
    this.bindScroll();
    // 添加全局点击事件监听
    document.addEventListener("click", this.handleClickOutside);
  },
  computed: {
    renderTips() {
      return this.searchType === 'account' ? '请输入达人ID、名称（如：新榜）' : '输入关键词搜索作品热度'
    },
    isWechatEnv() {
      const userAgent = navigator.userAgent.toLocaleLowerCase();
      return /micromessageer/.test(userAgent);
    },
    isPhone() {
      return (
        /Android|iPhone/i.test(navigator.userAgent) &&
        document.cookie.indexOf("sevFlag=1") < 0
      );
    },
    isMiniApp() {
      return navigator.userAgent.indexOf("miniProgram") > -1;
    },
    isIpad() {
      return (
        /iPad/i.test(navigator.userAgent) &&
        document.cookie.indexOf("sevFlag=1") < 0
      );
    },
    mainUrl() {
      let result = "https://www.newrank.cn";
      if (window.location.protocol === "http:") {
        result = "http://test.main.newrank.cn";
      }
      return result;
    },
    text() {
      return {
        id: this.number,
        val: this.newsData[this.number].title,
        url: this.newsData[this.number].url,
      };
    },
  },
  methods: {
    clearKeyWord() {
      this.serachInput = "";
    },
    toggleSearchType() {
      this.showSearchType = !this.showSearchType;
    },
    selectSearchType(type) {
      this.searchType = type;
      this.showSearchType = false;
    },
    changeSearchType() {
      this.showSearchType = !this.showSearchType;
    },
    handleClickOutside(event) {
      // 检查点击是否发生在搜索类型容器内部
      if (
        this.$refs.searchTypeContainer &&
        !this.$refs.searchTypeContainer.contains(event.target)
      ) {
        this.showSearchType = false;
      }
    },
    handleSearch() {
      let url = `https://www.newrank.cn/search/gongzhonghao/${
        this.serachInput || "新榜"
      }`;
      if(this.searchType === "trend") {
        url = `https://www.newrank.cn/search/m/trend${this.serachInput ? '?keyword=' + this.serachInput : ''}`;
      }
      window.location.href = url;
    },
    changeSerachInput(e) {
      const val = e.target.value;

      this.serachInput = val;
    },
    openAnnualH5(url) {
      //打开年度h5TODO:yzy
      window.location.href = url;
    },
    clickNewXItem(url) {
      window.location.href = url;
    },
    bindScroll() {
      let _this = this;
      document.addEventListener("scroll", function () {
        let top = document.body.scrollTop || document.documentElement.scrollTop;
        if (top > 600 && _this.cancheckFollowBar) {
          _this.checkFollowBar();
        }
      });
    },
    checkFollowBar() {
      const info = localStorage.getItem("NEWRANK_INFO")
        ? JSON.parse(localStorage.getItem("NEWRANK_INFO"))
        : {};
      this.cancheckFollowBar = false;
      if (info) {
        this.notFollowBar = info.subscribe == 0 ? true : false;
      }
    },
    changeUrl(str, type, percent) {
      return common.createBgUrl(str);
    },
    closeNotFollow() {
      this.notFollowBar = false;
    },
    getUser() {
      this.userInfo = localStorage.getItem("NEWRANK_USER")
        ? JSON.parse(localStorage.getItem("NEWRANK_USER"))
        : {};
      if (this.userInfo && /^.*?@newrank.cn$/.test(this.userInfo.name)) {
        this.getAdeData();
      }
    },
    getBangdanStatus() {
      newrankExhibition((result) => {
        this.bangdanNewStatus = result;
      });
    },
    getBanner() {
      mbGetBannerList(5, 3, (result) => {
        this.bannerData = result;
      });
    },
    getAdeData() {
      countAuditsRecordByUser((res) => {
        if (res.data > 0) {
          this.checkPendingNum = res.data;
        }
      });
    },
    doNull(i) {
      return common.doNull(i);
    },
    notFollow() {
      this.notFollowBar = false;
      this.codeShow = true;
      this.codeTitle = "新榜服务";
      this.codeImg = "newrankcs";
    },
    toSearch() {
      this.$router.push({
        name: "Search",
      });
    },
    toUser() {
      this.$router.push({
        name: "Info",
      });
    },
    toNewPage(url) {
      if (url) {
        window.location.href = url;
      }
    },
    toProduct(item) {
      if (item.text == "品牌榜" || item.text == "账号榜") return;
      let period = "";
      if (this.bangdanNewStatus == 1) {
        period = "day";
      } else if (this.bangdanNewStatus == 2) {
        period = "week";
      } else if (this.bangdanNewStatus == 3) {
        period = "month";
      }
      if (item.url) {
        if (item.text == "账号榜" && this.bangdanNewStatus != 4) {
          this.$router.push({
            name: "Rank",
            query: { period: period },
          });
        } else {
          window.location.href = item.url;
        }
      } else {
        this.$router.push({
          name: "Product",
        });
      }
    },
    showMoreNews() {
      this.moreNewsShow = true;
    },
    hideMoreNews() {
      this.moreNewsShow = false;
    },
    searchNotice() {
      mbSearchNews(7, (result) => {
        if (result.length) {
          this.moreNews = result;
          this.newsData = result.slice(0, 3);
          this.startMove();
        }
      });
    },
    startMove() {
      let maxLength = this.newsData.length;
      let timer = setTimeout(() => {
        if (this.number === maxLength - 1) {
          this.number = 0;
        } else {
          this.number += 1;
        }
        if (maxLength > 1) {
          this.startMove();
        }
      }, 1600);
    },
    searchCmsMedia() {
      searchCmsMedia((result) => {
        this.intelligenceData = result.informationList.slice(0, 5);
      });
      mbGetMedia(1, "", 1, 20, (result) => {
        this.informationData = result;
      });
    },
    toInformation(flag) {
      this.$router.push({ name: "Information", query: { flag: flag } });
    },
    wxData() {
      weixinShow({
        title: "新榜·内容产业服务",
        link: "http://test.main.newrank.cn/m/index",
        desc: "涨粉、变现、运营、观察，新榜给你不一样的新思路。",
        img: "https://newrank.oss-cn-hangzhou.aliyuncs.com/main/index.png",
      });
    },
    hanldeOpenSqWechat() {},
  },
};
</script>

<style lang="css" scoped>
.index {
  background-color: rgb(248, 249, 251);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.index-bannerAndSearch {
  height: 140px;
  position: relative;
}
.index-search {
  position: absolute;
  top: 15px;
  left: 15px;
  right: 15px;
  text-align: right;
}
.index-searchBox {
  width: 310px;
  height: 30px;
  border-radius: 15px;
  background-color: rgba(255, 255, 255, 0.3);
  display: inline-block;
  vertical-align: middle;
  line-height: 30px;
  color: rgba(255, 255, 255, 0.8);
}
.index-searchBox img {
  width: 13px;
  vertical-align: middle;
  margin-left: 20px;
}
.index-headerBox {
  width: 24px;
  height: 24px;
  /* text-align: center; */
  display: inline-block;
  vertical-align: middle;
  margin-left: 5px;
  border-radius: 50%;
  position: relative;
}
.index-headerBox img {
  max-width: 24px;
  border-radius: 50%;
}
.index-checkPending {
  position: absolute;
  right: 0;
  bottom: 10px;
  width: 111px;
  height: 36px;
  background: rgba(248, 249, 252, 1);
  border: 1px solid rgba(232, 232, 232, 1);
  border-radius: 18px 0px 0px 18px;
  box-sizing: border-box;
  padding-left: 15px;
  line-height: 36px;
}
.index-checkPending img {
  width: 24px;
  vertical-align: top;
  margin-top: 6px;
}

.main {
  padding: 20px 15px 60px;
  flex: 1;
  display: flex;
  flex-direction: column;
}
.index-linkList {
  height: 155px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  flex-wrap: wrap;
  margin-bottom: 10px;
  position: relative;
}

.wx-open-enter.wx-open-enter {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  width: 25%;
  height: 76px;
}
.linkList-item {
  flex: 25%;
  text-align: center;
  height: 76px;
  position: relative;
}
.linkList-item-icon {
  width: 40px;
  height: 40px;
  background-color: rgba(255, 120, 0, 0.2);
  border-radius: 50%;
  margin: 0 auto;
}
.linkList-item img {
  width: 24px;
  height: 24px;
  margin-top: 8px;
}
.linkList-item p {
  color: #707073;
  font-size: 12px;
  line-height: 36px;
}

.index-news {
  height: 36px;
  background-color: #fff;
  overflow: hidden;
  position: relative;
  font-size: 12px;
  line-height: 36px;
  border-radius: 5px;
}
.news-leftTitle {
  width: 16px;
  vertical-align: middle;
  margin: 0 10px 0 20px;
}
.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s linear;
}
.slide-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}
.slide-enter {
  transform: translateY(20px);
}
.text-container {
  display: inline-block;
  width: 260px;
  vertical-align: middle;
  overflow: hidden;
  line-height: 30px;
}
.news-more {
  font-size: 12px;
  color: #999;
  margin-left: -2px;
}

.index-intelligence {
  height: 300px;
  margin-top: 10px;
  background-color: #fff;
  border-radius: 5px;
}
.intelligence-head {
  height: 36px;
  line-height: 36px;
}
.intelligence-head-border {
  width: 3px;
  height: 18px;
  background-color: #ff7800;
  border-radius: 1px;
  display: inline-block;
  vertical-align: middle;
}
.intelligence-head-title {
  font-size: 16px;
  color: #333;
  vertical-align: middle;
  margin-left: 5px;
}
.intelligence-head img:last-child {
  float: right;
  margin-right: 10px;
  width: 6px;
  margin-top: 14px;
}
.intelligence-list {
  margin: 0 10px;
  padding: 10px 0 5px;
  border-top: 1px solid #f7f7fb;
}
.able-remind {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
  background-color: #cccccc;
  margin-right: 5px;
}
.intelligence-list-item {
  height: 45px;
}
.intelligence-list-item p:first-child {
  color: #333;
  font-size: 14px;
  line-height: 20px;
}
.intelligence-list-item p:last-child {
  font-size: 12px;
  color: #999;
  padding-left: 9px;
  line-height: 16px;
}
.index-information {
  margin-top: 10px;
  background-color: #fff;
  border-radius: 5px;
  padding-bottom: 10px;
}
.information-list-item {
  margin: 0 10px;
  border-top: 1px solid #f7f7fb;
  padding-top: 20px;
  padding-bottom: 6px;
  display: flex;
  justify-content: space-between;
}
.information-list-item-content {
  width: 220px;
}
.information-list-item-img {
  width: 100px;
  height: 70px;
  overflow: hidden;
  background-size: cover;
  background-position: center;
}
.information-list-item-content p:first-child {
  font-size: 16px;
  color: #333;
  line-height: 24px;
  min-height: 48px;
}
.information-list-item-content p:last-child {
  font-size: 12px;
  color: #999;
  margin-top: 3px;
}
.information-item-mini {
  padding: 0 5px;
  margin-left: 10px;
  height: 14px;
  display: inline-block;
  border: 1px solid #ccc;
  border-radius: 10px;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  vertical-align: top;
}
.linkList-bangdan-new-day {
  position: absolute;
  width: 46px;
  height: 15px;
  right: -8px;
  top: -4px;
}
.linkList-bangdan-new-day img {
  width: 100%;
  margin-top: 0;
  height: 100%;
}
.information-list-more {
  text-align: center;
  font-size: 12px;
  color: #999;
  margin-top: 20px;
}
.index-footer {
  font-size: 11px;
  color: #ccc;
  text-align: center;
  /* margin-top: 20px; */
  margin-top: auto;
}
.not-follow-newrank {
  position: fixed;
  /*top: 240px;*/
  bottom: 60px;
  left: 50%;
  margin-left: -125px;
  z-index: 3;
}
.not-follow-newrank-text {
  width: 250px;
  height: 30px;
  line-height: 30px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 6px;
  text-align: center;
  color: #ffffff;
  font-size: 12px;
}
.not-follow-newrank-close {
  width: 15px;
  height: 15px;
  background: #ffffff;
  border-radius: 100%;
  border: 1px solid #999999;
  color: #999999;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  position: absolute;
  right: -8px;
  top: -8px;
}
.index-advertisement {
  min-height: 50px;
  border-radius: 25px;
}
.index-advertisement img {
  width: 100%;
  height: 50px;
}

.annualH5 {
  width: 100%;
}
.annualH5 img {
  width: 100%;
}

.index-lnewXList .index-lnewXList-box {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.index-lnewXList-box-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 8px;
  width: calc(95% / 2);
  height: 32px;
  background-color: #fff;
  margin-bottom: 8px;
  font-size: 12px;
}
/* .index-lnewXList-box-item:first-child(

  ) */
.index-lnewXList-box-item > img {
  width: 14px;
  height: 14px;
  min-width: 14px;
  /* border-radius: 50%;
    overflow: hidden; */
}

.open-web,
.open-wechat {
  position: fixed;
  z-index: 10;
  bottom: 100px;
  left: 50%;
  width: 140px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transform: translateX(-50%);
  color: #fff;
  background: linear-gradient(297deg, #ff7800, #ffb700);
  border-radius: 16px;
  font-size: 14px;
}

.open-web > a {
  color: #fff;
}

.open-wechat-position {
  position: fixed;
  z-index: 11;
  bottom: 100px;
  left: 50%;
  transform: translateX(-50%);
}

.wx-open-enter.wx-open-enter {
  width: 100%;
  height: 100%;
}

.index-searchrow {
  width: 100%;
  height: max-content;
  padding: 0 10px;
  z-index: 10;
  box-sizing: border-box;
  transform: translateY(-50%);
}
.search-row {
  width: 100%;
  height: 40px;
  background: #ffffff;
  box-shadow: 0px 4px 4px 1px rgba(220, 230, 227, 0.4);
  border-radius: 4px;
  border: 1px solid #ececee;
  display: flex;
  align-items: center;
  padding: 10px;
  padding-right: 0;
  box-sizing: border-box;
  position: relative;
}
.search-row .search-icon {
  width: 14px;
  height: 14px;
  color: #949999;
}
.search-inputrow {
  flex: 1;
  margin: 0 auto;
  position: relative;
  border: none;
  color: #333;
  background: transparent !important;

  border-right: none;
  outline: none;
  font-size: 12px;
  padding-left: 5px;
  padding-right: 10px;
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  -webkit-appearance: none;
}

input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: none;
}
input[type="search"]::placeholder {
  color: #949999;
}

.search-row .search-btn {
  width: 62px;
  height: 38px;
  background: #ff7800;
  border-radius: 0px 3px 3px 0px;
  line-height: 38px;
  text-align: center;
  font-size: 13px;
  font-family: MiSans-Regular, MiSans;
  font-weight: 400;
  color: #ffffff;
}
.search-row .search-btn-trend {
  background: #0088ff;
}
.inputBox-clear {
  width: 15px;
  height: 15px;
  position: absolute;
  right: 70px;
}

.search-type-change {
  width: max-content;
  font-size: 12px;
  display: flex;
  align-items: center;
}

.search-type-icon {
  font-size: 12px;
  transition: all .3s;
}
.search-type-icon-active {
  transform: rotate(180deg);
}
.search-type-divider {
  font-size: 14px;
  color: #dee6e6;
  margin: 0 6px;
}
.search-type-option {
  width: 60px;
  height: max-content;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border-radius: 2px;
  background: white;
  font-size: 12px;
  position: absolute;
  bottom: -56px;
  left: 0;
  box-shadow: 0px 4px 4px 1px rgba(220, 230, 227, 0.4);
}
.search-type-option-item {
  width: 100%;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// index.vue?8e3b84ba